// Bouton de musique : rond et flottant (accueil, connexion, création du héros), ou ligne du menu du jeu avec le volume.
// `data-musique` : un toucher sur ce bouton ne relance pas la musique par le geste général (music/index.ts).
import { setMusicVolume, toggleMusic, useMusic } from "../music";
import "./MusicToggle.css";

export function MusicToggle({ variant }: { variant: "flottant" | "menu" }) {
  const { on, volume, playing } = useMusic();
  const label = !on ? "Mettre la musique" : playing ? "Couper la musique" : "Lancer la musique";

  if (variant === "flottant") {
    return (
      <button
        type="button"
        class={`musique-flottant${playing ? " is-playing" : ""}`}
        data-musique
        aria-label={label}
        aria-pressed={playing ? "true" : "false"}
        title={label}
        onClick={toggleMusic}
      >
        <span aria-hidden="true">{on ? "♫" : "♪"}</span>
        {!on && <span class="musique-barre" aria-hidden="true" />}
      </button>
    );
  }

  return (
    <div class="musique-menu" data-musique>
      <button type="button" class="btn btn-ghost game-menu-item" role="menuitem" aria-pressed={playing ? "true" : "false"} onClick={toggleMusic}>
        {on ? (playing ? "♫ Musique : en marche" : "♫ Lancer la musique") : "♪ Musique : coupée"}
      </button>
      {on && (
        <label class="musique-volume">
          <span class="musique-volume-label">Volume</span>
          <input
            type="range"
            min={0}
            max={100}
            step={5}
            value={Math.round(volume * 100)}
            onInput={(e) => setMusicVolume(Number(e.currentTarget.value) / 100)}
          />
        </label>
      )}
    </div>
  );
}
